import { reduxKey } from './constants';
import type { DiscordState } from './types';

export function getStoreSlice(state: any): DiscordState {
  return state[reduxKey] ?? { connection: {}, roles: {} };
}

export function getIsReduxInitialized(state: any) {
  return getStoreSlice(state).isReduxInitialized;
}

export function getDiscordGuildConnection(state: any) {
  return getStoreSlice(state).connection;
}

export function getDiscordGuildRoles(state: any) {
  return getStoreSlice(state).roles;
}
